import React, { memo } from 'react';
import { StyleSheet, View } from 'react-native';
import { rem } from 'design-system';
import Text from 'design-system/Text';
import QuoteInformation from './QuoteInformation';
const titleMap = {
    gas: 'Gas',
    electricity: 'Electricity',
};
const InformationLabelList = ({ filter, info }) => {
    const items = info?.filter((item) => item[filter]);
    if (!info || !items?.length) {
        return null;
    }
    return (<View>
      <Text Text-16 style={styles.title}>
        {titleMap[filter]}
      </Text>
      {items.map((item) => (<QuoteInformation key={item.name} title={item.name} text={item[filter]}/>))}
    </View>);
};
const styles = StyleSheet.create({
    title: {
        marginBottom: rem(20),
    },
});
export default memo(InformationLabelList);
